import { render, staticRenderFns } from "./Merchants.vue?vue&type=template&id=775ec18a&"
import script from "./Merchants.vue?vue&type=script&lang=ts&"
export * from "./Merchants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports